import { render } from "./CategoryFiltersTable.vue?vue&type=template&id=7f72a704&scoped=true"
import script from "./CategoryFiltersTable.vue?vue&type=script&lang=js"
export * from "./CategoryFiltersTable.vue?vue&type=script&lang=js"

import "./CategoryFiltersTable.vue?vue&type=style&index=0&id=7f72a704&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f72a704"]])

export default __exports__